import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import GreyWrapper from './common/GreyWrapper';
import DropdownCard from './common/DropdownCard';
import BestValueCheckbox from './components/BestValueCheckbox';
import { useFetchPersonalisedPlanStatus, useSavePersonalisedPlan } from './service';
import './PersonalisedStyle.css';
import ThreeMonthPlan from './components/ThreeMonthPlan';

export const buildEmailContent = (
  studentName: string,
  coachName: string,
  conciergeName: string,
  shortUrl: string
) => {
  return `
    <table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
    <tbody>
        <tr>
        <td>
            <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #fff8f2; border-bottom: 1px solid #f1dfd0; border-left: 1px solid #f1dfd0; border-radius: 7px; border-right: 1px solid #f1dfd0; border-top: 1px solid #f1dfd0; color: #000000; width: 600px; margin: 0 auto;" width="600">
            <tbody>
                <tr>
                <td class="column column-1" width="100%" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; padding-top: 5px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;">

                <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                    <tbody>
                        <tr>
                            <td style="padding-bottom:20px;padding-left:40px;padding-top:40px;text-align:center;width:100%">
                                <h1
                                    style="margin:0;color:#ff6a00;direction:ltr;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;font-size:22px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:left;margin-top:0;margin-bottom:0">
                                    <span style="word-break:break-word">${studentName}, your personalised yoga journey starts now!</span>
                                </h1>
                            </td>
                        </tr>
                    </tbody>
                </table>

                    <!-- Heading 2 -->
                    <table class="heading_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                        <tr>
                        <td class="pad" style="padding-left:40px;padding-right:40px;text-align:center;width:100%;">
                        <h1 style="margin: 0; color: #8e6445; direction: ltr; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 400; letter-spacing: normal; line-height: 150%; text-align: left; margin-top: 0; margin-bottom: 0; mso-line-height-alt: 16.8px;">
                            <span class="tinyMce-placeholder" style="word-break: break-word;">
                            Your teacher <strong style="margin-left:4px; margin-right:4px;">${coachName}</strong> and advisor <strong style="margin-left:4px; margin-right:4px;">${conciergeName}</strong> have designed a personalised yoga plan to help you:
                            </span>
                                </h1>
                            </td>
                        </tr>
                </table>

                    <!-- List of benefits -->
                    <table class="heading_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td class="pad" style="padding-top:5px;text-align:center;width:100%;">

                        <div style="display:flex;padding-left: 40px; margin-top: 20px">
                            <img src="https://cloudimages.myyogateacher.com/dgerdfai4/image/upload/v1708945658/Lv-landingpage/Tick.png" style="width:18px; height:18px; margin-right:5px">
                            <div>
                            <p style="margin-bottom:0;margin-top:0;text-align:left;font-family: Helvetica;font-size: 14px;font-style: normal;font-weight: 700;line-height: normal;color: #8E6445">
                                Achieve your health & wellness goals
                            </p>
                            </div>
                        </div>

                        <div style="display:flex;padding-left: 40px; margin-top: 20px">
                            <img src="https://cloudimages.myyogateacher.com/dgerdfai4/image/upload/v1708945658/Lv-landingpage/Tick.png" style="width:18px; height:18px; margin-right:5px">
                            <div>
                            <p style="margin-bottom:0;margin-top:0;text-align:left;font-family: Helvetica;font-size: 14px;font-style: normal;font-weight: 700;line-height: normal;color: #8E6445">
                                Stay consistent with expert guidance
                            </p>
                            </div>
                        </div>

                        <div style="display:flex;padding-left: 40px; margin-top: 20px">
                            <img src="https://cloudimages.myyogateacher.com/dgerdfai4/image/upload/v1708945658/Lv-landingpage/Tick.png" style="width:18px; height:18px; margin-right:5px">
                            <div>
                            <p style="margin-bottom:0;margin-top:0;text-align:left;font-family: Helvetica;font-size: 14px;font-style: normal;font-weight: 700;line-height: normal;color: #8E6445">
                                Progress at a pace that suits your lifestyle
                            </p>
                            </div>
                        </div>

                        <p style="padding-left: 40px;margin-bottom:0;margin-top:22px;text-align:left;font-family: Helvetica;font-size: 15px;font-style: normal;font-weight: 500;line-height: normal;color: #8E6445">
                            Your customised journey is ready — let’s take the first step together!
                        </p>

                        </td>
                    </tr>
                    </table>

                    <!-- Button -->
                    <table class="button_block block-4" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td class="pad" style="padding-left:40px;padding-top:20px;text-align:left;">
                        <div class="alignment" align="left">
                            <!--[if mso]>
                            <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{.session_token}}" style="height:56px;width:346px;v-text-anchor:middle;" arcsize="15%" stroke="false" fillcolor="#ee731b">
                            <w:anchorlock/>
                            <v:textbox inset="0px,0px,0px,0px">
                            <center dir="false" style="color:#fff;font-family:Arial, sans-serif;font-size:16px">
                            <![endif]-->
                            <a href="${shortUrl}" target="_blank" style="background-color:#ee731b;border-bottom:0px solid transparent;border-left:0px solid transparent;border-radius:8px;border-right:0px solid transparent;border-top:0px solid transparent;color:#fff;display:inline-block;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;mso-border-alt:none;padding-bottom:0px;padding-top:0px;text-align:center;text-decoration:none;width:auto;word-break:keep-all;">
                            <span style="word-break: break-word; padding-left: 18px; padding-right: 18px; font-size: 16px; display: inline-block; letter-spacing: normal; padding-top: 9px; padding-bottom: 9px; border-radius: 14px; display:flex; align-items: center">
                                <span style="word-break: break-word;">
                                <span class style="word-break: break-word; line-height: 32px;" data-mce-style>
                                    View My Personalised Plan
                                </span>
                                </span>
                            </span>
                            </a>
                            <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                        </div>
                        </td>
                    </tr>
                    </table>

                    <!-- Paragraph -->
                    <table class="paragraph_block block-5" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;">
                    <tr>
                        <td class="pad" style="padding-left:40px;padding-right:40px;padding-top:20px;padding-bottom:40px">
                        <div style="color:#8e6445;direction:ltr;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:15px;font-weight:400;letter-spacing:0px;line-height:150%;text-align:left;mso-line-height-alt:22.5px;">
                            <p style="margin: 0;">
                            We believe in your potential — thousands have transformed with MyYogaTeacher, now it’s your turn.
                            </p>
                        </div>
                        </td>
                    </tr>
                    </table>
                </td>
                </tr>
            </tbody>
            </table>
        </td>
        </tr>
    </tbody>
    </table>
  `;
};

// ---------------- Types ----------------
interface Plan {
  sessions_per_week: number | null;
  months: number | null;
  is_best_value: boolean;
  type: string;
}

interface GroupClass {
  uuid: string;
  name: string;
}

interface Notes {
  coach: string;
  ai: string;
  selected: 'teacher' | 'ai';
}

interface Lifestyle {
  current: string[];
  goals: string[];
}

interface PersonalisedPriceProps {
  studentDetails: {
    student_uuid: string;
    first_name: string;
    last_1on1_teacher_name?: string;
    three_months_plan_sent_to_student?: boolean;
  };
  data: any;
  onClose?: () => void;
}

const INITIAL_PLAN: Plan = {
  sessions_per_week: 0,
  months: null,
  is_best_value: false,
  type: ''
};

const INITIAL_NOTES: Notes = {
  coach:
    'Great work in class today. You brought a steady energy to the mat, and I really noticed how your breath stayed connected throughout the flow.',
  ai: 'Great work in class today. You brought a steady energy to the mat, and I really noticed how your breath stayed connected throughout the flow.',
  selected: 'teacher'
};

// ---------------- Component ----------------
const PersonalisedPlan: React.FC<PersonalisedPriceProps> = ({ studentDetails, data, onClose }) => {
  const [availablePlans, setAvailablePlans] = useState<any[]>([]);
  const [availableGroupClasses, setAvailableGroupClasses] = useState<GroupClass[]>([]);
  const [selectedPlanData, setSelectedPlanData] = useState({
    plans: [{ ...INITIAL_PLAN }, { ...INITIAL_PLAN }, { ...INITIAL_PLAN }],
    recommended_group_classes: [] as GroupClass[],
    notes: INITIAL_NOTES,
    lifestyle: { current: [], goals: [] } as Lifestyle
  });
  const [errorMsg, setErrorMsg] = useState('');

  const history = useHistory();
  const { planStatus, isFetchingStatus, fetchStatusError } = useFetchPersonalisedPlanStatus(
    studentDetails?.student_uuid
  );
  const { savePersonalisedPlan } = useSavePersonalisedPlan(studentDetails?.student_uuid);
  const formattedStudentFirstName =
    studentDetails?.first_name && studentDetails?.first_name.length > 0
      ? studentDetails?.first_name.charAt(0).toUpperCase() + studentDetails?.first_name.slice(1)
      : '';

  // ---------- Prefill data ----------
  useEffect(() => {
    if (data) {
      setAvailablePlans(data.plans || data.available_plans || []);
      setAvailableGroupClasses(data.recommended_classes || data.available_group_classes || []);

      // Prefill chosen plans
      const prefilledPlans = (data.chosen_plans || [])
        .filter((plan: any) => {
          const normalizedType = plan.type === 'Group Class' ? 'gc' : plan.type;
          if (!normalizedType) return false;
          if (normalizedType === '1on1')
            return Boolean(plan.months) && Boolean(plan.sessions_per_week);
          if (normalizedType === 'gc') return Boolean(plan.months);
          return false;
        })
        .map((plan: any) => ({
          sessions_per_week: plan.sessions_per_week ?? 0,
          months: plan.months ?? null,
          is_best_value: plan.is_best_value ?? false,
          type: plan.type === 'Group Class' ? 'gc' : plan.type
        }));

      while (prefilledPlans.length < 3) {
        prefilledPlans.push({ ...INITIAL_PLAN });
      }

      // Prefill notes
      let prefilledNotes = {
        coach: '',
        ai: '',
        selected: 'teacher' as 'teacher' | 'ai'
      };

      if (Array.isArray(data.notes)) {
        const teacherNote = data.notes.find((n: any) => n.note_type === 'teacher');
        const aiNote = data.notes.find((n: any) => n.note_type === 'ai');

        prefilledNotes = {
          coach: teacherNote?.note || '',
          ai: aiNote?.note || '',
          selected: teacherNote?.selected ? 'teacher' : aiNote?.selected ? 'ai' : 'teacher'
        };
      }

      // Parse goals if available
      let parsedGoals: string[] = [];
      const sourceGoals = data.main_goals ?? data.goals ?? null;
      if (Array.isArray(sourceGoals)) {
        parsedGoals = sourceGoals
          .map((g: any) => (typeof g === 'string' ? g.trim() : String(g)))
          .filter((g: string) => g.length > 0);
      } else if (typeof sourceGoals === 'string' && sourceGoals.length > 0) {
        parsedGoals = sourceGoals
          .split(',')
          .map((goal: string) => goal.trim())
          .filter((goal: string) => goal.length > 0);
      }

      setSelectedPlanData((prev) => ({
        ...prev,
        notes: prefilledNotes,
        lifestyle: {
          current: data.lifestyle || [],
          goals: parsedGoals.length > 0 ? parsedGoals : data.goals || []
        },
        plans: prefilledPlans,
        recommended_group_classes: data.chosen_group_classes || []
      }));
    }
  }, [data, studentDetails]);

  // ---------- Handlers ----------
  const updatePlanField = (index: number, field: keyof Plan, value: any) => {
    setSelectedPlanData((prev) => {
      const plans = [...prev.plans];
      plans[index] = { ...plans[index], [field]: value };
      return { ...prev, plans };
    });
  };

  const toggleBestValue = (index: number, checked: boolean) => {
    setSelectedPlanData((prev) => {
      const plans = prev.plans.map((plan, i) => {
        if (i === index) return { ...plan, is_best_value: checked };
        if (checked) return { ...plan, is_best_value: false };
        return plan;
      });
      return { ...prev, plans };
    });
  };

  const selectGroupClass = (index: number, gcName: string) => {
    const selected = availableGroupClasses.find((g) => g.name === gcName);
    if (!selected) return;

    setSelectedPlanData((prev) => {
      const rec = [...prev.recommended_group_classes];
      // ensure array has enough slots
      while (rec.length <= index) {
        rec.push({ uuid: '', name: '' } as GroupClass);
      }
      rec[index] = selected;
      return { ...prev, recommended_group_classes: rec };
    });
  };

  const validatePlan = (): string | null => {
    const hasPlanSelected = selectedPlanData.plans.some((plan) => plan.type && plan.type !== '');
    if (!hasPlanSelected) {
      return 'Please select at least one plan before saving.';
    }

    for (const plan of selectedPlanData.plans) {
      if (plan.type === '1on1') {
        if (!plan.months || !plan.sessions_per_week) {
          return 'For Private 1-on-1 Sessions, please select both Plan Duration and Sessions per Week.';
        }
      } else if (plan.type === 'gc') {
        if (!plan.months) {
          return 'For Group Class, please select Plan Duration.';
        }
      }
    }

    const seen = new Set<string>();
    for (const plan of selectedPlanData.plans) {
      if (!plan.type) continue;
      const key = `${plan.type}|${plan.months ?? ''}|${plan.sessions_per_week ?? ''}`;
      if (seen.has(key)) {
        return 'Each plan must be unique. Please change the duplicate plan before saving.';
      }
      seen.add(key);
    }

    return null;
  };

  const buildPayload = () => ({
    plans: selectedPlanData.plans.filter((plan) => plan.type && plan.type !== ''),
    recommended_group_classes: selectedPlanData.recommended_group_classes.filter((gc) => gc?.uuid),
    notes: selectedPlanData.notes,
    lifestyle: selectedPlanData.lifestyle.current,
    goals: selectedPlanData.lifestyle.goals
  });

  const onSavePlan = async () => {
    const error = validatePlan();
    if (error) {
      setErrorMsg(error);
      return;
    }

    try {
      await savePersonalisedPlan(buildPayload() as any);
      onClose?.();
    } catch (err) {
      console.error('Save failed', err);
    }
  };

  const onSharePlan = async () => {
    const error = validatePlan();
    if (error) {
      setErrorMsg(error);
      return;
    }

    try {
      await savePersonalisedPlan({ ...buildPayload(), send_to_student: true } as any);
      history.push(`/personalised-plan?student_uuid=${studentDetails?.student_uuid}`);
    } catch (err) {
      console.error('Share failed', err);
    }
  };

  useEffect(() => {
    if (errorMsg) {
      setErrorMsg('');
    }
  }, [selectedPlanData]);

  const groupClassOptions = availableGroupClasses.map((gc) => gc.name);

  /** Guard: check sent_to_student status on mount */

  if (isFetchingStatus) {
    return <div className="p-6 text-[#939393]">Loading...</div>;
  }

  if (fetchStatusError) {
    return <div className="p-6 text-[#FF2121]">{fetchStatusError}</div>;
  }

  if (planStatus?.sent_to_student) {
    history.push(`/personalised-plan?student_uuid=${studentDetails?.student_uuid}`);
    return null;
  }

  return (
    <div className="personalised-pricing font-[inter] max-w-[1000px] px-[20px] pb-[20px]">
      <h2 className="text-[19px] font-bold leading-[22px]">Personalised Plans</h2>
      <p className="text-[#939393] leading-[26px]">
        Select the options below to create a personalised plan.
      </p>

      <div className="mt-[6px] mb-[38px]">
        <ThreeMonthPlan
          studentUuid={studentDetails?.student_uuid}
          studentName={formattedStudentFirstName}
          teacherName={studentDetails?.last_1on1_teacher_name}
          isSentToStudent={studentDetails?.three_months_plan_sent_to_student}
        />
      </div>

      {/* ---------- Plan Selection ---------- */}
      <div className="grid grid-cols-2 gap-[20px]">
        {selectedPlanData.plans.map((plan, index) => {
          const planDef = availablePlans.find((p) => (p.plan_type || p.type) === plan.type);

          return (
            <div key={index} className="w-full flex flex-col gap-[6px]">
              <div className="text-[#838383] text-[10.5px] font-[625] leading-[18px]">
                {`PLAN ${['ONE', 'TWO', 'THREE'][index]}`}
              </div>
              <GreyWrapper>
                {/* --- Plan Type Dropdown --- */}
                <DropdownCard
                  value={
                    plan.type
                      ? plan.type === '1on1'
                        ? 'Private 1-on-1 Sessions'
                        : 'Group Class'
                      : null
                  }
                  label="Select a plan type"
                  items={availablePlans.map((p) =>
                    (p.plan_type || p.type) === '1on1' ? 'Private 1-on-1 Sessions' : 'Group Class'
                  )}
                  onSelect={(val) =>
                    updatePlanField(index, 'type', val === 'Group Class' ? 'gc' : '1on1')
                  }
                />

                {/* --- Only show duration + sessions/best value if plan chosen --- */}
                {plan.type && (
                  <>
                    <div className="flex gap-[20px] mt-4">
                      {/* Plan Duration */}
                      <div className="w-full">
                        <p className="mt-[21px] mb-[8px]">Plan Duration</p>
                        <DropdownCard
                          value={
                            plan.months ? `${plan.months} Month${plan.months > 1 ? 's' : ''}` : null
                          }
                          label="Select Duration"
                          items={
                            planDef?.months?.map((m: number) => `${m} Month${m > 1 ? 's' : ''}`) ||
                            []
                          }
                          onSelect={(val) => updatePlanField(index, 'months', parseInt(val))}
                        />
                      </div>

                      {/* Sessions per week only for 1on1 */}
                      {plan.type === '1on1' && (
                        <div className="w-full">
                          <p className="mt-[21px] mb-[8px]">Sessions per Week</p>
                          <DropdownCard
                            value={plan.sessions_per_week ? `${plan.sessions_per_week}` : null}
                            label="Select Sessions"
                            items={planDef?.sessions_per_week?.map((s: number) => `${s}`) || []}
                            onSelect={(val) =>
                              updatePlanField(index, 'sessions_per_week', parseInt(val))
                            }
                          />
                        </div>
                      )}
                    </div>

                    {/* Best Value checkbox always visible if plan selected */}
                    <BestValueCheckbox
                      checked={plan.is_best_value}
                      onChange={(checked) => toggleBestValue(index, checked)}
                    />
                  </>
                )}
              </GreyWrapper>
            </div>
          );
        })}
      </div>

      {/* ---------- Group Classes ---------- */}
      <div className="w-full flex flex-col mt-6">
        <div className="flex w-full items-center justify-between">
          <p className="text-[#838383] text-[10.5px] font-[625] uppercase">
            Recommend group classes
          </p>
          <p className="text-[#838383] text-[10.5px] font-[625]">Optional</p>
        </div>
        <GreyWrapper customStyle="flex gap-[20px]">
          <DropdownCard
            value={selectedPlanData.recommended_group_classes[0]?.name || null}
            label="Select Group class 1"
            items={groupClassOptions}
            onSelect={(val) => selectGroupClass(0, val)}
            searchable={true}
          />
          <DropdownCard
            value={selectedPlanData.recommended_group_classes[1]?.name || null}
            label="Select Group class 2"
            items={groupClassOptions}
            onSelect={(val) => selectGroupClass(1, val)}
            searchable={true}
          />
        </GreyWrapper>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <button
          onClick={onSavePlan}
          className="w-fit border border-[#E7E7E7] font-[600] text-[17px] leading-[21px] py-[14px] px-[22px] rounded-[14px] text-[#321A50] bg-white dark:bg-gray-800 shadow-[0px_2px_4px_0px_rgba(188,188,188,0.22)] hover:opacity-80 cursor-pointer"
        >
          Save Plan
        </button>
        <button
          onClick={onSharePlan}
          className="w-fit border font-[600] text-[17px] leading-[21px] py-[14px] px-[22px] rounded-[14px] bg-[#EE731B] text-white shadow-[0px_2px_4px_0px_rgba(248,102,36,0.15)] hover:opacity-80 cursor-pointer"
        >
          Share Plan
        </button>

        {errorMsg && (
          <p className="text-[#FF2121] md:text-[15.5px] zm:text-[12.5px] font-medium my-[10px] ">
            {errorMsg}
          </p>
        )}
      </div>
    </div>
  );
};

export default PersonalisedPlan;
